module.exports = __webpack_public_path__ + "img/woocommerce.404c87bc.png";